import { IFirstHandReport } from '@/api/home/types';
import { IResortPathInfo } from '@/api/resort/types';
import { Routes } from '@/routes';
import { formatAgoTimestampOrString } from '@/util/formatAgo';
import { NewsCard } from '@/components/common/NewsCard';

// Single FHR tile on the home carousel. Same visual shape as the
// News card so the two carousels read as one product:
//   - 4:3 cover photo with hover zoom
//   - "RESORT · TIMESTAMP" eyebrow
//   - bold title
//   - 2-line body excerpt
//
// Maps the IFirstHandReport fields onto NewsCard so all editorial
// tiles on home share one primitive.

export const FirstHandReportItem = ({
  title, largeImage, translated, date, name, resortPathInfo,
}: IFirstHandReport & { resortPathInfo?: IResortPathInfo }) => {
  const href = resortPathInfo
    ? Routes.resortSnowReport(resortPathInfo)
    : undefined;

  return (
    <NewsCard
      title={title}
      excerpt={translated}
      image={largeImage}
      // Eyebrow shows the report's author (the title already carries the
      // resort name). Falls back to no label when the report is anonymous.
      category={name ?? undefined}
      date={formatAgoTimestampOrString(date)}
      href={href}
      className="h-full"
    />
  );
};
